import { LOCAL_STORAGE_ROLES, LOCAL_STORAGE_TOKEN } from "../../constans/roles";
import { LOGOUT, SET_ROLES } from "../../constans/reducerActions";
import { loginUser } from "../../utils/api/userApi";

const INFO_TYPE_FAIL = "Fail";

const MISSING_DATA_MESSAGE = "Nie podano wszystkich danych";
const LOGIN_RETRY_MESSAGE = "Blad logowania, sprobuj ponownie!";
const LOGIN_RUNTIME_ERROR_MESSAGE = "Blad w czasie logowania!";

const clearLoginForm = (setLogin, setPass) => {
  setLogin("");
  setPass("");
};

const applySession = (data) => {
  localStorage.setItem(LOCAL_STORAGE_TOKEN, data.token);
  localStorage.setItem(LOCAL_STORAGE_ROLES, data.roles);
};

export const validateLoginForm = (login, password) => {
  if (!login || !password) {
    return MISSING_DATA_MESSAGE;
  }

  return "";
};

export function createLoginController({
  dispatch,
  navigate,
  setInfoType,
  setInfo,
  setLogging,
  setLogin,
  setPass,
}) {
  const handleLoginFailure = (message) => {
    setInfo(message);
    setInfoType(INFO_TYPE_FAIL);
    dispatch({ type: LOGOUT });
    clearLoginForm(setLogin, setPass);
    setLogging(false);
  };

  const submitLogin = async (login, password) => {
    try {
      setLogging(true);
      const response = await loginUser(login, password);
      const data = response?.data || {};

      if (!data.token) {
        handleLoginFailure(LOGIN_RETRY_MESSAGE);
        return false;
      }

      applySession(data);
      dispatch({ type: SET_ROLES, item: { roles: data.roles } });
      setLogging(false);
      clearLoginForm(setLogin, setPass);
      navigate("/");
      window.location.reload(false);
      return true;
    } catch (error) {
      handleLoginFailure(LOGIN_RUNTIME_ERROR_MESSAGE);
      navigate("/login");
      return false;
    }
  };

  return {
    submitLogin,
  };
}
